{
  "Quantity": "Quantità",
  "Item": "Articolo",
  "CMEnvironment": "ECM",
  "TelephonyServer": "Server di telefonia",
  "Partitions": "Divisori",
  "Devices": "Dispositivi",
  "Agents": "Agenti",
  "ReportingUsers": "Segnalazione degli utenti",
  "NonReportingUsers": "Utenti non dichiaranti",
  "Estate_ButtonHelpLabel": "Aiuto?",
  "Estate_ButtonSubmitLabel": "OK",
  "Estate_ButtonCancelLabel": "Annullamento",
  "Estate_PromptMessage": "Siete sicuri di voler chiudere questa finestra? Tutte le configurazioni modificate andranno perse una volta chiuse.",
  "Estate_PromptConfirm": "Sì",
  "Estate_PromptCancel": "Annullamento",
  "NAME": "Estate"
}